import React from 'react';
import { Link } from 'react-router-dom';

import usePricingNavigationStyles from './useStyles';

type NavItemProps = {
  title: string;
  selected: string;
  url: string;
};

export default function NavItem({ title, selected, url }: NavItemProps): React.ReactElement {
  const { ListItem } = usePricingNavigationStyles();

  return (
    <li className={`${ListItem} ${selected}`}>
      <Link to={url}>
        <strong>{title}</strong>
      </Link>
    </li>
  );
}
